<script lang="ts">
	import cake from "../../../core/assets/icons/cake.svg?raw";
	import { weddingsCakeEnquiryPathMap, weddingsPathMap } from "../../../core/schema/paths/weddingsPathMap";
	import { getGlobalSettings } from "../getGlobalSettings";
	import Link from "./Link.svelte";

	export let hide = false;

	const { TENANT_LOCALE } = getGlobalSettings();

	const urlSlug = `/${weddingsPathMap[TENANT_LOCALE]}#${weddingsCakeEnquiryPathMap[TENANT_LOCALE]}`;
</script>

<div
	class="pointer-events-none fixed bottom-0 left-0 right-0 z-40 h-[7.25rem] transition-transform sm:h-[6.5rem]"
	class:translate-y-full={hide}
>
	<div class="bg-panel-shadow h-[2.25rem]"></div>
	<div
		class="border-secondary-150 pointer-events-auto flex h-[calc(100%-2.25rem)] flex-col items-center justify-center gap-2 border-t bg-white py-2 sm:flex-row sm:gap-12 lg:gap-16 xl:gap-20"
	>
		<p class="lg:text-md font-semibold text-black">Chci svatební dort od Sladké dílny</p>
		<Link asButton type="submit" variant="primary" icon={cake} iconClass="h-4" href={urlSlug}>
			Poptat termín výroby
		</Link>
	</div>
</div>
